import {
  TableContainer as ChakraTableContainer,
  TableContainerProps as ChakraTableContainerProps,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export type TableContainerProps = OmitChakraProps<ChakraTableContainerProps>;

export const TableContainer = forwardRef<TableContainerProps, 'div'>(
  (props, ref) => {
    return (
      <ChakraTableContainer
        {...props}
        ref={ref}
        sx={{ overflowY: 'auto', whiteSpace: false }}
      />
    );
  },
);
